export const setTranslationColumn = obj =>
  Object.keys(obj).includes('is_translation') ? (obj.is_translation ? 'Yes' : 'No') : 'N/A';
